import { CALL_SET_CONSULT_TYPE } from "../constants/action-types";
import { SHOW_LOADER, SHOW_TAB } from "../constants/constants";

const initialState = {
  isLoading: false,
  tab: "Call",
  consultType: "",
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case SHOW_TAB:
      return {
        ...state,
        tab: action.tab,
      };
    case CALL_SET_CONSULT_TYPE:
      return {
        ...state,
        consultType: action.consultType,
      };
    default:
      return state;
  }
}
